import * as types from './types'
import action from '../middleware'

export const fetchClientReport = ({ clientId, recordId }) => (dispatch) =>
  action(
    {
      endpoint: `/v1/facility/clients/${clientId}/records/${recordId}/report`,
      method: 'GET',
      actionTypes: {
        requestType: types.FETCH_CLIENT_REPORT,
        successType: types.FETCH_CLIENT_REPORT_SUCCESS,
        failureType: types.FETCH_CLIENT_REPORT_FAILURE,
      },
    },
    dispatch
  )

export const fetchClientSummary = (clientId) => (dispatch) =>
  action(
    {
      endpoint: `/v1/facility/clients/${clientId}/records/summary`,
      method: 'GET',
      actionTypes: {
        requestType: types.FETCH_CLIENT_SUMMARY,
        successType: types.FETCH_CLIENT_SUMMARY_SUCCESS,
        failureType: types.FETCH_CLIENT_SUMMARY_FAILURE,
      },
    },
    dispatch
  )

export const resetClientReport = () => ({
  type: types.RESET_CLIENT_REPORT,
})

// Fetch snap details for HW v7 scans (includes vat_mass, metabolic_age, etc.)
export const fetchClientSnapDetails = ({ clientId, recordId }) => (dispatch) =>
  action(
    {
      endpoint: `/facility/clients/${clientId}/records/${recordId}/snap-details`,
      method: 'GET',
      actionTypes: {
        requestType: types.FETCH_CLIENT_SNAP_DETAILS,
        successType: types.FETCH_CLIENT_SNAP_DETAILS_SUCCESS,
        failureType: types.FETCH_CLIENT_SNAP_DETAILS_FAILURE,
      },
    },
    dispatch
  )
